/// <amd-module name="Work/Views/MyWork/Contracts/MyWorkItemsDecorated" />
import { WorkItem } from "Wit/Clients/Wit/Contracts/WorkItemTracking";

export interface MyWorkItemsDecorated extends WorkItem {
    sectionName: string;
    sectionKey: string;
}
